import FootballResultModel from "./Football/FootballResultModel";
import FootballResultView from "../../components/Sports/Football/FootballResultView";
import FutsalResultModel from "./Futsal/FutsalResultModel";
import FutsalResultView from "../../components/Sports/Futsal/FutsalResultView";

export const sportModules = {
  FOOTBALL: {
    type: "football_result_v1",
    Model: FootballResultModel,
    View: FootballResultView,
  },
  FUTSAL: {
    type: "futsal_result_v1",
    Model: FutsalResultModel,
    View: FutsalResultView,
  },
};